<template>
    <div :data-component="'strat.'+prod.title+'.vid-det.v12020'">
        <div class="max hidden-xs-only">
            <div class="close-btn text-center">
                <v-btn rounded text @click="killDialog()">
                    <i class="las la-times black--text" style="font-size: 34px"></i>
                </v-btn>
            </div>
            <div class="breadcrum text-center">
                <span class="dolo t20 black--text">{{prod.title}}</span>
            </div>
            <div class="promo-banner white">
                <div class="dolo bg black--text">
                    <v-layout fill-height justify-center align-center>
                        {{prod.title}}
                    </v-layout>
                </div>
                <div class="title-area">
                    <div class="dolo" style="font-size: 6rem; letter-spacing: -6px; line-height: 100px;">{{prod.title}}</div>
                    <v-card class="mt-4 mb-10" flat height="8" width="74" :color="prod.color"></v-card>
                    <div class="dolo t40 text-uppercase mb-8">{{prod.tagline}}</div>
                    <div class="roboto grey--text">{{prod.desc}}</div>
                </div>
                <div class="logo-area" :class="prod.req"></div>
            </div>
            <div class="section" :class="prod.color">
                <v-layout justify-center>
                    <v-flex xs12 md9>
                        <v-layout row wrap align-center>
                            <v-flex xs12 md6 pr-8>
                                <div class="dolo white--text big">Quick Hot statement that will pull people in.</div>
                            </v-flex>
                            <v-flex xs12 md6>
                                <div class="roboto white--text dets">{{prod.desc}}</div>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </div>
            <div v-if="launched" class="vid-section black">
                <iframe width="100%" height="100%" :src="'https://www.youtube.com/embed/'+prod.promoVid+'?autoplay=1&amp;mute=1&amp;loop=1'" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
            <div class="section text-center" :class="prod.color2">
                <v-layout justify-center class="content">
                    <v-flex xs12 md8 my-12>
                        <div class="dolo white--text big-xl" style="">Measurement always precedes mangement.</div>
                    </v-flex>
                </v-layout>
            </div>
            <div  v-if="launched" class="section highlights white">
                <div :class="prod.color2" class="top-over">
                </div>
                <div class="highlight-container">
                    <div class="left-btn">
                        <v-layout fill-height align-center justify-center>
                            <v-btn v-if="hilyte != 0" color="black" class="btn" @click="last()">
                                <i class="white--text las la-arrow-left t40"></i>
                            </v-btn>
                        </v-layout>
                    </div>
                    <div class="right-btn">
                        <v-layout fill-height align-center justify-center>
                            <v-btn v-if="hilyte != hilyteTotal - 1" color="black" class="btn" @click="next()">
                                <i class="white--text las la-arrow-right t40"></i>
                            </v-btn>
                        </v-layout>
                    </div>
                    <v-card elevation="24" class="max">
                        <v-window class="max" v-model="hilyte">
                            <v-window-item class="hilyte-item max" v-for="(h,i) in prod.highlights" :key="i">
                                <v-layout fill-height justify-center align-center>
                                    <div class="window-bg bgGrey">
                                       <v-img cover :src="h.img"></v-img>
                                    </div>
                                    <div class="window-content">
                                        <div class="content-title dolo">{{h.title}}</div>
                                        <v-card flat height="10" width="120" :color="prod.color" class="mt-8 mb-12"></v-card>
                                        <div class="content-detail roboto">
                                            {{h.desc}}.
                                        </div>
                                    </div>
                                </v-layout>
                            </v-window-item>
                        </v-window>
                    </v-card>
                </div>
                <div class="bottom-buttons">
                    <v-item-group
                        v-model="hilyte"
                        class="text-center"
                        mandatory
                    >
                        <v-item
                            v-for="n in hilyteTotal"
                            :key="`btn-${n}`"
                            v-slot:default="{ active, toggle }"
                            class="ma-2"
                        >
                        <v-btn
                            :input-value="active"
                            icon
                            @click="toggle"
                        >
                            <v-avatar :color="hilyte == n - 1 ? prod.color2 : 'bgGrey'" size="12"></v-avatar>
                            <!-- <i class="las la-circle" :class=""></i> -->
                        </v-btn>
                        </v-item>
                    </v-item-group>
                </div>
            </div>
            <div class="section white text-center">
                <v-layout justify-center class="content">
                    <v-flex xs12 md6>
                        <div class="text-center">
                            <v-avatar size="140" tile class="prod-logo" :class="prod.req"></v-avatar>
                        </div>
                        <div class="dolo big-xl">{{prod.smarter}} Smarter with Strategery {{prod.title}}.</div>
                        <v-btn x-large class="t18 px-8 my-12 white--text" rounded :color="prod.color2" @click="openGetStarted()">Get Started.</v-btn>
                        <div class="t24 roboto grey--text">Or contact us about scheduling a demo.</div>
                    </v-flex>
                </v-layout>
            </div>
            <div v-if="launched" class="section" :class="prod.color2">
                <v-layout justify-center>
                    <v-flex xs12 md8 offset-md2>
                        <div v-for="(a,i) in prod.articles" :key="i" class="article-item">
                            <div class="roboto article-title white--text font-weight-light">{{a.title}}</div>
                            <div class="dolo article-ref white--text mt-6">{{a.source}}</div>
                        </div>
                    </v-flex>
                </v-layout>
            </div>
            <div class="section black">
                <v-layout justify-center>
                    <v-flex xs12 md9>
                        <v-layout justify-space-between align-center>
                            <v-flex shrink>
                                <v-layout align-center class="t24 white--text">
                                    <span class="text-uppercase font-weight-light">
                                        <span class="font-weight-black" style="font-size: 2em">{{prod.title}}</span>
                                    </span>
                                    <span class="mx-8">
                                        <v-card flat height="30px" width="1" color="white"></v-card>
                                    </span>
                                    <span class="roboto ls6" :class="prod.color+'--text'">
                                        {{prod.tagline}}
                                    </span>
                                </v-layout>
                            </v-flex>
                            <v-flex shrink>
                                <v-layout row wrap justify-end class="white--text">
                                    <v-flex shrink ml-3 class="footer-link">
                                        <span class="text-right t18 lulu mr-4">Terms of Service</span>
                                    </v-flex>
                                    <v-flex shrink ml-3 class="footer-link">
                                        <span class="text-right t18 lulu">Privacy Policy</span>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap justify-end>
                                    <v-flex xs12 class="text-right grey--text text-darken-1">
                                        <span class="text-right t18 lulu"> © {{cry}} DoloLabs LLC. All Rights Reserved.</span>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </div>
        </div>
        <div class="mobi max hidden-sm-and-up">
            <div class="close-btn text-center">
                <v-btn rounded text @click="killDialog()">
                    <i class="las la-times black--text" style="font-size: 34px"></i>
                </v-btn>
            </div>
            <div class="promo-banner white">
                <div class="title-area px-5">
                    <div class="dolo mt-8" style="font-size: 2.8em; letter-spacing: -5.5px; line-height: 50px;">{{prod.title}}</div>
                    <v-card class="mt-4 mb-12" flat height="4" width="44" :color="prod.color"></v-card>
                    <div class="dolo t18 text-uppercase mb-4">{{prod.tagline}}</div>
                    <div class="roboto grey--text t14">{{prod.desc}}</div>
                </div>
                <div class="logo-area" :class="prod.req"></div>
            </div>
            <div class="section" :class="prod.color">
                <v-layout justify-center px-12>
                    <v-flex xs12 md9>
                        <v-layout row wrap align-center>
                            <v-flex xs12 md6>
                                <div class="dolo white--text mb-12" style="font-size: 2em">Quick Hot statement that will pull people in.</div>
                            </v-flex>
                            <v-flex xs12 md6>
                                <div class="roboto white--text t14">{{prod.desc}}</div>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </div>
            <div v-if="launched" class="vid-section black">
                <iframe width="100%" height="100%" :src="'https://www.youtube.com/embed/'+prod.promoVid+'?autoplay=1&amp;mute=1&amp;loop=1'" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
            <div class="section text-center px-12" :class="prod.color2">
                <v-layout justify-center class="content">
                    <v-flex xs12 md8 my-12>
                        <div class="dolo white--text" style="font-size: 3em; line-height: 50px;">Measurement always precedes mangement.</div>
                    </v-flex>
                </v-layout>
            </div>
            <div  v-if="launched" class="section highlights white">
                <div :class="prod.color2" class="top-over">
                </div>
                <div class="highlight-container">
                    <v-card elevation="0" class="max">
                        <v-window class="max" v-model="hilyte">
                            <v-window-item class="hilyte-item max" v-for="(h,i) in prod.highlights" :key="i">
                                <v-layout fill-height justify-center align-center>
                                    <div class="window-bg grey lighten-4">
                                       <!-- <v-img cover :src="h.img"></v-img> -->
                                    </div>
                                    <div class="window-content px-6">
                                        <div class="content-title dolo">{{h.title}}</div>
                                        <v-card flat height="6" width="50" :color="prod.color" class="mt-4 mb-8"></v-card>
                                        <div class="content-detail roboto t14">
                                            {{h.desc}}.
                                        </div>
                                    </div>
                                </v-layout>
                            </v-window-item>
                        </v-window>
                    </v-card>
                </div>
                <div class="bottom-buttons">
                    <v-item-group
                        v-model="hilyte"
                        class="text-center"
                        mandatory
                    >
                        <v-item
                            v-for="n in hilyteTotal"
                            :key="`btn-${n}`"
                            v-slot:default="{ active, toggle }"
                            class="ma-1"
                        >
                        <v-btn
                            :input-value="active"
                            icon
                            @click="toggle"
                        >
                            <v-avatar :color="hilyte == n - 1 ? prod.color2 : 'bgGrey'" size="12"></v-avatar>
                            <!-- <i class="las la-circle" :class=""></i> -->
                        </v-btn>
                        </v-item>
                    </v-item-group>
                </div>
            </div>
            <div class="section white text-center">
                <v-layout justify-center class="content">
                    <v-flex xs12 md6>
                        <div class="text-center">
                            <v-avatar size="100" tile class="prod-logo" :class="prod.req"></v-avatar>
                        </div>
                        <div class="dolo px-8 mt-8" style="font-size: 2em; line-height: 40px;">{{prod.smarter}} Smarter with Strategery {{prod.title}}.</div>
                        <v-btn large class="t14 px-8 my-12 white--text" rounded :color="prod.color2" @click="openMobiGetStarted()">Get Started.</v-btn>
                        <div class="t14 roboto grey--text px-8">Or contact us about scheduling a demo.</div>
                    </v-flex>
                </v-layout>
            </div>
            <div v-if="launched" class="section" :class="prod.color2">
                <v-layout justify-center>
                    <v-flex xs12 md8 offset-md2>
                        <div v-for="(a,i) in prod.articles" :key="i" class="article-item">
                            <div class="roboto article-title white--text font-weight-light">{{a.title}}</div>
                            <div class="dolo article-ref white--text mt-6">{{a.source}}</div>
                        </div>
                    </v-flex>
                </v-layout>
            </div>
        </div>
        <v-dialog v-model="getStartedDialog" width="60%">
            <v-card color="white" class="max overflow-hidden pa-6">
                <get-started @killGetStarted="killGetStarted()"/>
            </v-card>
        </v-dialog>
        <v-dialog v-model="mobiGetStartedDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card color="white" class="max overflow-hidden pa-6">
                <get-started @killGetStarted="killGetStarted()"/>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import getStarted from '../views/contact_sales'

export default {
    components: {
        getStarted
    },
    props: {
        prod: Object,
        launched: Boolean,
    },
    mounted(){
        this.hilyteTotal = this.prod.highlights.length
    },
    data: () => {
        return {
            hilyte: 0,
            hilyteTotal: null,
            hiPics: 0,
            getStartedDialog: false,
            mobiGetStartedDialog: false,
        }
    },
    methods: {
        killDialog(){
            this.$emit('killProdDialog')
        },
        next(){
            this.hilyte = this.hilyte + 1
            this.hiPics = this.hiPics + 1
        },
        last(){
            this.hilyte = this.hilyte - 1
            this.hiPics = this.hiPics + 1
        },
        openMobiGetStarted() {
            this.mobiGetStartedDialog = true
        },
        openGetStarted() {
            this.getStartedDialog = true
        },
        killGetStarted() {
            this.mobiGetStartedDialog = false
            this.getStartedDialog = false
        }
    }
}
</script>

<style lang="scss" scoped>

    .close-btn {
        position: absolute;
        left: 0;
        top: 2%;
        width: 100%;
        height: 50px;
        z-index: 5;
    }
    .breadcrum {
        position: absolute;
        left: 0;
        width: 100%;
        top: 6%;
        height: 50px;
        z-index: 5;
    }

    .vid-section {
        height: 95vh;
        position: relative;
        
        .vid {
            position: absolute;
            height: 100%;
            width: 100%;
        }
    }

    .section {
        position: relative;
        padding: 125px 0;
       // min-height: 60vh;

       .big-xl {
            font-size: 6em;
            line-height: 80px;
        }

       .big {
           font-size: 4em;
           line-height: 90px;
       }

       .dets {
           font-size: 24px;
       }

        .content {
            /* position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            min-height: 500px; */
            z-index: 1;
        }

        &.highlights {
            height: 96vh;

            .top-over {
                position: absolute;
                top: 0;
                width: 100%;
                height: 10%;
                left: 0;
            }

            .highlight-container {
                position: absolute;
                top: 0;
                height: 90%;
                width: 90%;
                left: 5%;
                z-index: 2;

                .left-btn {
                    position: absolute;
                    left: -50px;
                    top: 0;
                    height: 100%;
                    width: 100px;
                    z-index: 5;

                    .btn {
                        height: 100px;
                        width: 100px !important;
                    }
                }
                .right-btn {
                    position: absolute;
                    right: -50px;
                    top: 0;
                    height: 100%;
                    width: 100px;
                    z-index: 5;

                    .btn {
                        height: 100px;
                        width: 100px !important;
                    }
                }
            }

            .bottom-buttons {
                max-height: 100px;
                width: 100%;
                position: absolute;
                left: 0;
                bottom: 0%;
            }
        }
    }

    .promo-banner {
        height: 98vh;
        overflow: hidden;

        .bg {
            position: absolute;
            height: 95vh;
            width: 100%;
            left: 0;
            top: 0;
            font-size: 20em;
            letter-spacing: -30px;
            opacity: .074;
        }

        .title-area {
            position: absolute;
            height: 50%;
            width: 36%;
            left: 14%;
            top: 40%;
        }
        .logo-area {
            position: absolute;
            height: 50%;
            width: 50%;
            right: 0;
            top: 33%;
            background-size: contain;
            background-position: center;

            &.iq {
                background-image: url('../assets/logos/iq/iq_shad2.png')
            }
            &.td {
                background-image: url('../assets/logos/today/td_shad2.png')
            }
            &.av {
                background-image: url('../assets/logos/avenues/av_shad2.png')
            }
            &.pe {
                background-image: url('../assets/logos/people/pe_shad2.png')
            }
        }
    }

    .prod-logo {
        background-position: center;
        background-size: contain;

        &.iq {
            background-image: url('../assets/logos/iq/iq_shad2.png')
        }
        &.td {
            background-image: url('../assets/logos/today/td_shad2.png')
        }
        &.av {
            background-image: url('../assets/logos/avenues/av_shad2.png')
        }
        &.pe {
            background-image: url('../assets/logos/people/pe_shad2.png')
        }
    }

    .rblft {
        border-radius: 0 240px 240px 0;
        position: absolute;
        height: 60%;
        width: 60%;
        left: 0;
        top: 20%;
        z-index: 0;
        opacity: .34;

        &.outlined {
            border: 10px solid;
        }
    }

    .article-item {
        margin: 60px 0;

        .article-title {
            font-size: 5em;
            line-height: 70px;
        }

        .article-ref {
            font-size: 2.2em;
        }
    }

    .footer-link {
        cursor: pointer;
        color: #9e9e9e !important;
        text-decoration: none !important;

        &:hover {
            color: #e91e63 !important;
            text-decoration: none !important;
        }
    }

    .hilyte-item {
        .window-bg {
            position: absolute;
            height: 80%;
            width: 89%;
            top: 10%;
            right: 0;
            overflow: hidden;
            border-radius: 100px 0 0 100px;

            .window-title {
                font-size: 16em;
                letter-spacing: -30px;
                opacity: .074;
                line-height: 160px;
                //white-space: nowrap
            }
        }

        .window-content {
            position: absolute;
            height: 30%;
            width: 50%;
            top: 26%;
            left: 8%;
            z-index: 7;

            .content-title {
                font-size: 6em;
                letter-spacing: -6.5px;
                line-height: 74px;
            }

            .content-detail {
                line-height: 40px;
                font-size: 24px;
            }
        }
    }

    .prod-vid-sec {
        position: absolute;
        top: 8%;
        width: 100%;
        left: 0%;
        height: 80%;
        z-index: 2; 

        .laptop-mock {
            height: 584px;
            width: 764px;
            background-image: url('../assets/laptop-mock.png');
            background-size: contain;
            background-position: center;

            .preview-frame {
                border-radius: 3px;
                margin-top: 64px;
                margin-left: 93px;
                height: 358.5px;
                width: 574px;
                overflow: hidden;
            }
        }
    }

    .tablet {
        .close-btn {
            position: absolute;
            left: 0;
            top: 2%;
            width: 100%;
            height: 50px;
            z-index: 5;
        }

        .breadcrum {
            position: absolute;
            left: 0;
            width: 100%;
            top: 6%;
            height: 50px;
            z-index: 5;
        }

        .vid-section {
            height: 95vh;
            position: relative;
            
            .vid {
                position: absolute;
                height: 100%;
                width: 100%;
            }
        }

        .section {
            position: relative;
            padding: 125px 0;

            .big-xl {
                font-size: 4em;
                line-height: 60px;
            }

            .big {
                font-size: 2.5em;
                line-height: 40px;
            }

            .dets {
                font-size: 16px;
            }

            .content {
                z-index: 1;
            }

            &.highlights {
                height: 96vh;

                .top-over {
                    position: absolute;
                    top: 0;
                    width: 100%;
                    height: 10%;
                    left: 0;
                }

                .highlight-container {
                    position: absolute;
                    top: 0;
                    height: 90%;
                    width: 90%;
                    left: 5%;
                    z-index: 2;

                    .left-btn {
                        display: none;
                    }
                    .right-btn {
                        display: none;
                    }
                }

                .bottom-buttons {
                    max-height: 100px;
                    width: 100%;
                    position: absolute;
                    left: 0;
                    bottom: 0%;
                }
            }
        }

        .promo-banner {
            height: 98vh;
            overflow: hidden;

            .bg {
                position: absolute;
                height: 95vh;
                width: 100%;
                left: 0;
                top: 0;
                font-size: 12em;
                letter-spacing: -30px;
                opacity: .074;
            }

            .title-area {
                position: absolute;
                height: 50%;
                width: 36%;
                left: 14%;
                top: 18%;
            }
            .logo-area {
                position: absolute;
                height: 50%;
                width: 50%;
                right: 0;
                top: 25%;
                background-size: contain;
                background-position: center;

                &.iq {
                    background-image: url('../assets/logos/iq/iq_shad2.png')
                }
                &.td {
                    background-image: url('../assets/logos/today/td_shad2.png')
                }
                &.av {
                    background-image: url('../assets/logos/avenues/av_shad2.png')
                }
                &.pe {
                    background-image: url('../assets/logos/people/pe_shad2.png')
                }
            }
        }

        .prod-logo {
            background-position: center;
            background-size: contain;

            &.iq {
                background-image: url('../assets/logos/iq/iq_shad2.png')
            }
            &.td {
                background-image: url('../assets/logos/today/td_shad2.png')
            }
            &.av {
                background-image: url('../assets/logos/avenues/av_shad2.png')
            }
            &.pe {
                background-image: url('../assets/logos/people/pe_shad2.png')
            }
        }

        .rblft {
            border-radius: 0 240px 240px 0;
            position: absolute;
            height: 60%;
            width: 60%;
            left: 0;
            top: 20%;
            z-index: 0;
            opacity: .34;

            &.outlined {
                border: 10px solid;
            }
        }

        .article-item {
            margin: 60px 0;

            .article-title {
                font-size: 3.5em;
                line-height: 50px;
            }

            .article-ref {
                font-size: 1.2em;
            }
        }

        .footer-link {
            cursor: pointer;
            color: #9e9e9e !important;
            text-decoration: none !important;

            &:hover {
                color: #e91e63 !important;
                text-decoration: none !important;
            }
        }

        .hilyte-item {
            .window-bg {
                position: absolute;
                height: 80%;
                width: 89%;
                top: 10%;
                right: 0;
                overflow: hidden;
                border-radius: 100px 0 0 100px;

                .window-title {
                    font-size: 16em;
                    letter-spacing: -30px;
                    opacity: .074;
                    line-height: 160px;
                    //white-space: nowrap
                }
            }

            .window-content {
                position: absolute;
                height: 30%;
                width: 50%;
                top: 26%;
                left: 8%;
                z-index: 7;

                .content-title {
                    font-size: 3em;
                    letter-spacing: -2.5px;
                    line-height: 44px;
                }

                .content-detail {
                    line-height: 26px;
                    font-size: 16px;
                }
            }
        }

        .prod-vid-sec {
            position: absolute;
            top: 8%;
            width: 100%;
            left: 0%;
            height: 80%;
            z-index: 2; 

            .laptop-mock {
                height: 584px;
                width: 764px;
                background-image: url('../assets/laptop-mock.png');
                background-size: contain;
                background-position: center;

                .preview-frame {
                    border-radius: 3px;
                    margin-top: 64px;
                    margin-left: 93px;
                    height: 358.5px;
                    width: 574px;
                    overflow: hidden;
                }
            }
        } 
    }

    .mobi {
        .close-btn {
            position: absolute;
            left: 0;
            top: 2%;
            width: 100%;
            height: 50px;
            z-index: 5;
        }
        .breadcrum {
            position: absolute;
            left: 0;
            width: 100%;
            top: 6%;
            height: 50px;
            z-index: 5;
        }

        .vid-section {
            height: 55vh;
            position: relative;
            
            .vid {
                position: absolute;
                height: 100%;
                width: 100%;
            }
        }

        .section {
            position: relative;
            padding: 55px 0;
            // min-height: 60vh;

            .content {
                /* position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                min-height: 500px; */
                z-index: 1;
            }

            &.highlights {
                height: 96vh;

                .top-over {
                    position: absolute;
                    top: 0;
                    width: 100%;
                    height: 10%;
                    left: 0;
                }

                .highlight-container {
                    position: absolute;
                    top: 0;
                    height: 100%;
                    width: 100%;
                    left: 0;
                    z-index: 2;
                }

                .bottom-buttons {
                    max-height: 100px;
                    width: 100%;
                    position: absolute;
                    left: 0;
                    bottom: 0%;
                    z-index: 4;
                }
            }
        }

        .promo-banner {
            height: 98vh;
            overflow: hidden;

            .bg {
                position: absolute;
                height: 70vh;
                width: 100%;
                left: 0;
                top: 8%;
                font-size: 7em;
                letter-spacing: -10px;
                opacity: .074;
            }

            .title-area {
                position: absolute;
                height: 50%;
                width: 90%;
                left: 5%;
                top: 30%;
            }
            .logo-area {
                position: absolute;
                height: 16%;
                width: 100%;
                right: 0;
                top: 13%;
                background-size: contain;
                background-position: center;

                &.iq {
                    background-image: url('../assets/logos/iq/iq_shad2.png')
                }
                &.td {
                    background-image: url('../assets/logos/today/td_shad2.png')
                }
                &.av {
                    background-image: url('../assets/logos/avenues/av_shad2.png')
                }
                &.pe {
                    background-image: url('../assets/logos/people/pe_shad2.png')
                }
            }
        }

        .prod-logo {
            background-position: center;
            background-size: contain;

            &.iq {
                background-image: url('../assets/logos/iq/iq_shad2.png')
            }
            &.td {
                background-image: url('../assets/logos/today/td_shad2.png')
            }
            &.av {
                background-image: url('../assets/logos/avenues/av_shad2.png')
            }
            &.pe {
                background-image: url('../assets/logos/people/pe_shad2.png')
            }
        }

        .rblft {
            border-radius: 0 240px 240px 0;
            position: absolute;
            height: 60%;
            width: 60%;
            left: 0;
            top: 20%;
            z-index: 0;
            opacity: .34;

            &.outlined {
                border: 10px solid;
            }
        }

        .article-item {
            margin: 50px 0;
            padding: 0 50px;

            .article-title {
                font-size: 2em;
                line-height: 40px;
            }

            .article-ref {
                font-size: 1.2em;
            }
        }

        .footer-link {
            cursor: pointer;
            color: #9e9e9e !important;
            text-decoration: none !important;

            &:hover {
                color: #e91e63 !important;
                text-decoration: none !important;
            }
        }

        .hilyte-item {
            .window-bg {
                position: absolute;
                height: 80%;
                width: 89%;
                top: 10%;
                right: 0;
                overflow: hidden;
                border-radius: 100px 0 0 100px;

                .window-title {
                    font-size: 16em;
                    letter-spacing: -30px;
                    opacity: .074;
                    line-height: 160px;
                    //white-space: nowrap
                }
            }

            .window-content {
                position: absolute;
                height: 30%;
                width: 90%;
                top: 26%;
                left: 5%;
                z-index: 7;

                .content-title {
                    font-size: 2em;
                    letter-spacing: -2.5px;
                    line-height: 30px;
                }

                .content-detail {
                    line-height: 20px;
                }
            }
        }

        .prod-vid-sec {
            position: absolute;
            top: 8%;
            width: 100%;
            left: 0%;
            height: 80%;
            z-index: 2; 

            .laptop-mock {
                height: 584px;
                width: 764px;
                background-image: url('../assets/laptop-mock.png');
                background-size: contain;
                background-position: center;

                .preview-frame {
                    border-radius: 3px;
                    margin-top: 64px;
                    margin-left: 93px;
                    height: 358.5px;
                    width: 574px;
                    overflow: hidden;
                }
            }
        }
    }

</style>